import { appConstants } from '../actions/appAction';


const initialState = {
  isLogin     : false,
  token       : null,
  currentUser : null,
};

export function app (state = initialState, action) {
  switch (action.type) {


    case appConstants.SET_LOGIN_DATA:
      return {
        ...state,
        isLogin : true,
        token: action.token,
        currentUser: action.data,
      };


    case appConstants.LOGOUT:
      return {
        ...state,
        isLogin : false,
        token: null,
        currentUser: null,
      };

    default:
      return state;
  }
};
